import { registerComponent } from '@gig/magic-common';
import MarketingPreferencesComponent from './marketing-preferences.vue.js';

var MarketingPreferences = registerComponent(MarketingPreferencesComponent);

export { MarketingPreferences };
